import React, { useState } from 'react';

import { PriceRowContextContainer } from '../price-row-context';

import { insertTableAds } from '../ads';
import { OptionTypeEnum } from 'src/components/filter-dropdown';
import { getOffersWithUnfeaturedPlaceholder } from '../unfeatured-offers-placeholder';
import PriceListFooter from './price-list-footer';

import { useProductPageUnfeaturedOffersPlaceholderExperiment } from 'src/hooks/experiments';

import {
  createOfferFromPriceItem,
  getUnfeaturedPlaceholderData,
} from '../utils';

import { Price } from 'src/types';
import { PriceRow } from '../price-row/row-types';
import { IPriceListBodyProps } from './types';

import { PriceList } from './styles';

export const PriceListBody: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceListBodyProps>
>> = props => {
  const {
    sortedPrices,
    numberOfVisiblePrices,
    productName,
    productId,
    media,
    brand,
    campaign,
    isPrimaryList,
    currentSorting = OptionTypeEnum.CHEAPEST_PRICE,
    showProductInformationTexts,
  } = props;

  const showUnfeaturedOffersPlaceholderExperiment = useProductPageUnfeaturedOffersPlaceholderExperiment();

  const unfeaturedPlaceholderData = getUnfeaturedPlaceholderData(
    showUnfeaturedOffersPlaceholderExperiment,
    sortedPrices
  );

  const [showUnfeaturedPlaceholder, setShowUnfeaturedPlaceholder] = useState(
    Boolean(unfeaturedPlaceholderData)
  );
  const [showMorePrices, setShowMorePrices] = useState(false);

  const filteredPrices = sortedPrices.filter(item => {
    // Filter to only show featured offers if placeholder should be shown
    return showUnfeaturedOffersPlaceholderExperiment &&
      unfeaturedPlaceholderData &&
      showUnfeaturedPlaceholder
      ? item.store?.featured && item.externalUri
      : item;
  });

  const insertUnfeaturedOffersPlaceholder = (offerRows: JSX.Element[]) =>
    unfeaturedPlaceholderData && showUnfeaturedPlaceholder
      ? getOffersWithUnfeaturedPlaceholder(
          offerRows,
          setShowUnfeaturedPlaceholder,
          unfeaturedPlaceholderData
        )
      : offerRows;

  return (
    <>
      <PriceList>
        {sortedPrices &&
          sortedPrices.length > 0 &&
          insertTableAds(
            insertUnfeaturedOffersPlaceholder(
              filteredPrices
                .slice(0, showMorePrices ? undefined : numberOfVisiblePrices)
                .map((item, index) => {
                  const rowKey = `${item.id}-${index}`;
                  const offer = createOfferFromPriceItem(item as Price);

                  return (
                    <PriceRowContextContainer
                      key={rowKey}
                      productId={productId}
                      productName={productName}
                      productImage={media?.first}
                      brand={brand}
                      campaign={campaign}
                      showExpandButton
                      offer={offer}
                      isFeatured={Boolean(offer.featured && offer.externalUri)}
                      sorting={currentSorting}
                      setShowUnfeaturedPlaceholder={() =>
                        setShowUnfeaturedPlaceholder(true)
                      }
                      showUnfeaturedHideButton={Boolean(
                        unfeaturedPlaceholderData
                      )}
                    >
                      <>
                        <PriceRow
                          item={item}
                          index={index}
                          isInPrimaryList={isPrimaryList}
                        />
                      </>
                    </PriceRowContextContainer>
                  );
                })
            )
          ).map(row => <li key={row.key}>{row}</li>)}
      </PriceList>
      <PriceListFooter
        showProductInformationTexts={showProductInformationTexts}
        offersCount={filteredPrices.length}
        showMorePrices={showMorePrices}
        numberOfVisiblePrices={numberOfVisiblePrices}
        setShowMorePrices={setShowMorePrices}
      />
    </>
  );
};
